import React from 'react'
import { useParams } from 'react-router'

function ReceipeDescription() {
    const { name } = useParams();
    return (
        <>
            
        </>
    )
}

export default ReceipeDescription
